import { useMutation, useQueryClient } from '@tanstack/react-query';
import { archivePartnerGroupChannel } from '../services/partnerGroupChannel';
import { partnerGroupChannelQueryKeys } from './use-partner-group-channel-query';

export const useArchivePartnerGroupChannelMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async () => {
      const result = await archivePartnerGroupChannel();

      if (!result.success) {
        throw new Error(result.message || 'Failed to archive community channel');
      }

      return result;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: partnerGroupChannelQueryKeys.all });
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
